import { MEASUREMENT_UNITS } from "infrastructure/constants";

const SIZES = ["", "k", "M", "G", "T"];
const MAGNITUDE_UNITS = ["", "k", "mln", "bln"];

export const bytesToSize = bytes => {
  if (bytes == 0) return { value: 0, units: MEASUREMENT_UNITS.BYTES };
  return getShortValueWithPrefixedUnit({
    number: bytes,
    unit: "B",
    isByte: true,
    precision: 3,
  });
};

export function shortenWithNotation(numberObject) {
  const precision = numberObject.precision || 4;
  const number = Math.abs(numberObject.number);
  const divider = numberObject.divider || 1000;
  let sign = 1;
  if (numberObject.number < 0) {
    sign = -1;
  }

  if (number < divider) {
    return { number: number * sign, orderOfMagnitude: 0 };
  }

  const index = Math.floor(Math.log(number) / Math.log(divider));
  const value =
    sign *
    parseFloat((number / Math.pow(divider, index)).toPrecision(precision));

  return { number: value, orderOfMagnitude: index };
}

export function getShortValueWithPrefixedUnit(numberObject) {
  const { number, unit, isByte, precision } = numberObject;

  if (isNaN(number) || number == null) {
    return { value: "-", units: "" };
  }

  if (unit === MEASUREMENT_UNITS.MILLISECONDS) {
    return number >= 1000
      ? {
          value: parseFloat((number / 1000).toFixed(precision)),
          units: MEASUREMENT_UNITS.SECONDS,
        }
      : {
          value: parseFloat(number.toFixed(precision)),
          units: MEASUREMENT_UNITS.MILLISECONDS,
        };
  }

  if (unit === MEASUREMENT_UNITS.REQUESTS_PER_SECOND) {
    return { value: parseFloat(number.toFixed(precision)), units: unit };
  }

  const numberResult = shortenWithNotation({
    number: number,
    divider: isByte ? 1024 : 1000,
  });
  if (
    (isByte && SIZES[numberResult.orderOfMagnitude] === undefined) ||
    (!isByte && MAGNITUDE_UNITS[numberResult.orderOfMagnitude] === undefined)
  ) {
    return { value: number.toExponential(precision), units: unit || "" };
  }
  const units = isByte
    ? SIZES[numberResult.orderOfMagnitude] + unit
    : (MAGNITUDE_UNITS[numberResult.orderOfMagnitude] +
        " " +
        (unit || "")
      ).trim();
  return { value: parseFloat(numberResult.number.toFixed(precision)), units };
}
